<template>
    <q-dialog v-model="modalFavorites"
              persistent
              transition-show="scale"
              transition-hide="scale"
              :maximized="$q.platform.is.mobile">
        <q-card class="modal-favorites">
            <div class="modal-header">
                <div class="modal-close" @click.prevent="close()">
                <span aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         x="0px" y="0px" width="10px"
                         height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                        <path d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                    </svg>
                </span>
                </div>
            </div>
            <q-card-section class="modal-content q-pb-md">
                <h3>Товар добавлен в избранное</h3>

                <section>Войдите в профиль, чтобы сохранить список. Несохранённый список будет очищен через 7 дней.</section>

                <div class="controls-wrapper row q-col-gutter-x-md">
                    <div class="col">
                        <q-btn outline label="Продолжить" @click.prevent="close()"/>
                    </div>
                    <div class="col">
                        <q-btn square outlined color="primary" label="Войти" @click.prevent="login()"/>
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
    name: "Favorites",
    computed: {
        ...mapState('auth', ['logged']),
        ...mapState('product', ['modalFavorites']),
    },
    methods: {
        ...mapMutations('product', ['toggleFavoritesModal']),
        ...mapMutations('auth', ['showModal']),
        close() {
            this.toggleFavoritesModal(false);
        },
        login() {
            this.close();
            this.showModal();
        }
    }
}
</script>

